import React from 'react';
import Dropzone from 'react-dropzone';

export default class FileField extends React.Component {
  handleDrop = (acceptedFiles, rejectedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      this.props.onChange(file);
    }

    // call custom handler
    if (this.props.dropzoneOnDrop) {
      this.props.dropzoneOnDrop(acceptedFiles, rejectedFiles);
    }
  };

  render() {
    let {
      // eslint-disable-next-line
      onChange,
      // eslint-disable-next-line
      onBlur,
      // eslint-disable-next-line
      onError,
      // eslint-disable-next-line
      value,
      // eslint-disable-next-line
      dropzoneOnDrop,
      ...extraProps
    } = this.props;

    return (
      <Dropzone onDrop={this.handleDrop} {...extraProps}>
        {this.props.children}
      </Dropzone>
    );
  }
}
